export default __webpack_public_path__ + "static/media/tiktok-visits.44f6f405.png";